import { CreditsOverview } from 'src/dto/Credits';
import { ChartData } from 'src/frontend-common/components/Charts/ChartsTypes';
import { AlertAnalyticWrapper, GetAnalyticsParams, NewPeriodOverview } from 'src/frontend-common/dto/Interfaces/Analytics';
import { retryApi } from './baseApi';

export interface Payment {
  id: number;
  app_key: string;
  creation_date: string;
  activation_date: string;
  expiration_date: string;
  frequency: string;
  value: string;
  source: string;
  company_name: string;
}

export interface Product {
  lookups: number;
  credits: number;
  claim: 'phone' | 'name' | 'email' | 'domain' | 'ip' | 'score' | 'bot_detection';
}

interface PaymentsResponse {
  items: Payment[];
  total: number;
}

export interface CompanyUsage {
  lookups: number;
  credits: number;
  balance: number;
  company: {
    name: string;
    usage: string;
  };
}

interface DateParams {
  start_date: string;
  end_date: string;
}
const adminDashboardApi = retryApi.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query<PaymentsResponse, DateParams>({
      query: (params) => ({
        url: '/v1/admin/dashboard/payments',
        params: {
          ...params,
        },
      }),
    }),

    getCompanies: builder.query<ChartData, DateParams>({
      query: (params) => ({
        url: '/v1/admin/dashboard/analytics/companies',
        params: {
          start_date: params.start_date,
          end_date: params.end_date,
        },
      }),
    }),
    getPeriodOverview: builder.query<NewPeriodOverview, GetAnalyticsParams>({
      query: (params) => ({
        url: '/v1/admin/dashboard/analytics/overview',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),

    getTopCountries: builder.query<AlertAnalyticWrapper, { start_date: string; end_date: string; field: string }>({
      query: (params) => ({
        url: '/v1/admin/dashboard/countries/usage',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),
    getProductUsage: builder.query<Product[], DateParams>({
      query: (params) => ({
        url: '/v1/admin/dashboard/products/usage',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),
    getCompanyUsage: builder.query<CompanyUsage[], DateParams>({
      query: (params) => ({
        url: '/v1/admin/dashboard/companies/usage',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),
    getProductLookups: builder.query<CreditsOverview, { start_date: string; end_date: string; field: string; average_type: string }>({
      query: (params) => ({
        url: '/v1/admin/dashboard/lookups/products',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),
    getCompanyLookups: builder.query<CreditsOverview, { start_date: string; end_date: string; field: string; average_type: string }>({
      query: (params) => ({
        url: '/v1/admin/dashboard/lookups/companies',
        params: {
          ...params,
        },
      }),
      providesTags: ['New PeriodOverview'],
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useGetPeriodOverviewQuery,
  useGetCompaniesQuery,
  useGetTopCountriesQuery,
  useGetProductUsageQuery,
  useGetCompanyUsageQuery,
  useGetProductLookupsQuery,
  useGetCompanyLookupsQuery,
} = adminDashboardApi;
